import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { LegacyDialogsService as DialogsService } from '../services/legacy-dialogs.service';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

export const unsavedDataDeactivate: CanDeactivateFn<ComponentCanDeactivate> = (
  component: ComponentCanDeactivate
): boolean | Observable<boolean> => {
  const dialogService = inject(DialogsService);

  if (component.canDeactivate()) {
    return true;
  } else {
    const message = $localize`Все несохраненные изменения будут утеряны. Покинуть страницу ?`;
    return dialogService.confirm(message);
  }
};
